import TruncateDiv from './TruncateDiv';
import { shouldRightAlignProperty } from '../utils/shouldRightAlignProperty';
import PropertyCellDisplayContent from './PropertyCellDisplayContent';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `PropertyViewCell` is a thin wrapper around PropertyCellDisplayContent that is used to display a property value in a table cell.
 * It provides opinionated styling and routes to either a custom cell renderer or a FormattedPropertyV2 to display the property value.
 *
 * `PropertyTableCell` is a heavier alternative that should be used in any case where you want to support inline
 * editing of a property value in the table cell.
 */
const PropertyViewCell = ({
  value,
  objectTypeId,
  objectId,
  propertyDefinition,
  canEditObject,
  getSecondaryPropertyValue,
  requiredCellProps
}) => /*#__PURE__*/_jsx("td", Object.assign({}, requiredCellProps, {
  children: /*#__PURE__*/_jsx(TruncateDiv, {
    rightAligned: shouldRightAlignProperty(propertyDefinition),
    children: /*#__PURE__*/_jsx(PropertyCellDisplayContent, {
      value: value,
      objectId: objectId,
      objectTypeId: objectTypeId,
      propertyDefinition: propertyDefinition,
      canEditObject: canEditObject,
      getSecondaryPropertyValue: getSecondaryPropertyValue
    })
  })
}));
export default PropertyViewCell;